import { render, staticRenderFns } from "./chatBody.vue?vue&type=template&id=505d7098&scoped=true"
import script from "./chatBody.vue?vue&type=script&lang=ts"
export * from "./chatBody.vue?vue&type=script&lang=ts"
import style0 from "./chatBody.vue?vue&type=style&index=0&id=505d7098&prod&lang=css"
import style1 from "./chatBody.vue?vue&type=style&index=1&id=505d7098&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505d7098",
  null
  
)

export default component.exports